export class FormatRegistry {
    constructor() {
        this.definitions = [];
        this.byExtension = new Map();
    }
    register(definition) {
        for (const extension of definition.extensions) {
            const existing = this.byExtension.get(extension);
            if (existing) {
                throw new Error(`Format extension "${extension}" is already registered`);
            }
            this.byExtension.set(extension, definition);
        }
        this.definitions.push(definition);
    }
    find(extension) {
        return this.byExtension.get(extension.toLowerCase()) ?? null;
    }
    /** Every registered extension in a category, for messages and UI lists. */
    extensionsFor(category) {
        return this.definitions
            .filter(definition => definition.category === category)
            .flatMap(definition => [...definition.extensions]);
    }
    allExtensions() {
        return [...this.byExtension.keys()];
    }
    has(extension) {
        return this.byExtension.has(extension.toLowerCase());
    }
}
export const formats = new FormatRegistry();
